'use strict';
const angular = require('angular');

export default angular.module('appApp.maptoolbar', [])
  .directive('maptoolbar', function() {
    return {
      template: require('./maptoolbar.html'),
      restrict: 'EA',
      link: function(scope, element, attrs) {}
    };
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/directives/maptoolbar/maptoolbar.directive.js